import { ICurrencyMap } from '../contracts';
import currencies from './currencies.json';

export const CurrencyMap = currencies as ICurrencyMap;
export const CurrencyCodes = Object.getOwnPropertyNames(CurrencyMap);
export const Currencies = Object.values(CurrencyMap);